import {
  EVENT_ACTION_ADD,
  EVENT_CATEGORY_ACTIVITIES,
  EVENT_TARGET_TYPE_ANSWER,
} from 'approot/shared/data-tracker/data-events.constants';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  ActivitiesAnswerType,
  ActivitiesComponentType,
  ActivitiesContentType,
  ASSESSMENT,
  LESSON,
  LESSON_ACTIVITIES,
} from 'global/constants';

export type Answer = {
  __typename: 'ActivityAnswer';
  uuid: string;
  componentId: string;
  activityId: string;
  answerType: ActivitiesAnswerType | null;
};

export function pushStudentAnswerEvent({
  answer,
  contentId,
  contentType,
  version,
  dataTrackingComponentType,
}: {
  answer: Answer;
  contentId: number;
  contentType: ActivitiesContentType;
  version: string;
  dataTrackingComponentType?: ActivitiesComponentType;
}) {
  pushDataTrackerEvent(EVENT_CATEGORY_ACTIVITIES, EVENT_ACTION_ADD, {
    target_type: EVENT_TARGET_TYPE_ANSWER,
    target_identifier: answer.uuid,
    target_subtype: dataTrackingComponentType,
    content_id: contentId,
    content_type: contentType === LESSON_ACTIVITIES ? LESSON : ASSESSMENT,
    version: version,
    activity_id: answer.activityId,
    activity_component_id: answer.componentId,
  });
}
